module.exports = __webpack_public_path__ + "img/triangle2green.898b8212.png";